import { Component } from "@angular/core";
import { WindowLayoutDirective } from "@lib/base/directives/window-layout.directive";

@Component({
    selector: "app-topbar",
    imports: [],
    templateUrl: "./topbar.component.html",
    styleUrl: "./topbar.component.scss",
    hostDirectives: [WindowLayoutDirective],
})
export class TopbarComponent {

}
